import { Injectable } from '@angular/core';
import { BaseApiService } from '@smartera/core';
import { Urls } from '@core/config';
import { catchError, Observable } from 'rxjs';
import { SharedDashboard } from '@api/models';

@Injectable()
export class SharedDashboardService extends BaseApiService<any> {
	get apiUrl(): string {
		return Urls.BASE_URL.toString() + '/analytic/shared-dashboards';
	}

	public findDashboardsByCurrentUser(): Observable<SharedDashboard[]> {
		return this._restClientService
			.get(`${this.apiUrl}/find-dashboards-by-current-user`)
			.pipe(catchError(this.handleError));
	}
}
